import React, { useState, useEffect } from "react";
import Signin from "f1-signin-form-react";
import cslogo1 from "./../../assets/img/barcodelogo.png";
import Loader from "./../loader/loader";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import "./login.scss";
import { ApiUrls, TENANT_SEARCH_NEW } from "../../api/baseURL";
import { useNavigate } from "react-router-dom";
import shibbolethLogo from "./../../assets/img/logo-shibboleth.png";
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux'
import { login } from "../../features/userSlice";
import packageJson from "../../../package.json";
import { post } from "../../api/api";
import { addToCollection } from "../../offlineManager/localbase";
import { metaDataConstants } from "../../utils/Constants/constants-en";

function LogIn() {

  const [activateLoader, setActivateLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [showGeneralError, setShowGeneralError] = useState(false);
  const [generalErrorMessage, setGeneralErrorMessage] = useState("");
  
  const navigate = useNavigate();

  const rememberMe = (value) => {
    console.log(value.formData.rememberme);
  };

  useEffect(() => {
    localStorage.removeItem("timer")
    // calling this API on page load as response of this API will be used as Header for other APIs
    // getServiceToken()
  }, []);

  const getServiceToken = async (tenant) => {
    // change this payload as per QA/ training or Prod server

    // const payload = {
    //   domainName: "fulcrumww.com",
    //   clientName: "suite",
    //   applicationTokenName: "Web",
    //   applicationName: "demo",
    //   multiTenant: "fulcrum",

    // }
    // const payload = { "domainName": "fulcrumww.com", "clientName": 'suite', "applicationTokenName": "Web", "applicationName": "demo", "multiTenant": tenant }
    const payload = {"domainName":"fulcrumww.com","clientName":"suite","applicationTokenName":"Web","applicationName":tenant == 'OKDOC'? 'demo': "live","multiTenant": tenant}
    const response = await axios
      .post(
        ApiUrls().SERVICE_TOKEN,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShowGeneralError(true)
        setGeneralErrorMessage(metaDataConstants.somethingWrong)
        console.error("Error:", error);
      });

    if (response?.status === 200) {

      localStorage.setItem("privateKey", response?.data.serviceToken.privateKey)
      localStorage.setItem("applicationTenantLinkId", response?.data.serviceToken.applicationTenantLinkId)
      localStorage.setItem("applicationKey", response?.data.serviceToken.applicationKey)
      localStorage.setItem("tenantKey", response?.data.serviceToken.tenantKey)
      localStorage.setItem("tokenId", response?.data.serviceToken.tokenId)
      localStorage.setItem("tokenKey", response?.data.serviceToken.tokenKey)

      return response
    }
  };

  const getTenantMetaData = async (tenant) => {
    let tenantData;
    const tenantMetadataResponse = await axios.get(TENANT_SEARCH_NEW() + `?TenantName=${tenant}`)
      .catch(err => {
        console.log(err)
        setShowGeneralError(true)
        setGeneralErrorMessage(metaDataConstants.invalidTenant)
        setActivateLoader(false)
        return
      })
    if (tenantMetadataResponse?.status === 200) {
      console.log(tenantMetadataResponse)
      if (tenantMetadataResponse?.data?.isSuccess) {
        tenantData = JSON.parse(tenantMetadataResponse?.data?.result)
        localStorage.setItem("base-url", tenantData.CSWCF + '/')
        return true
      } else {
        setActivateLoader(false)
        if (tenantMetadataResponse?.data?.errorCode === "InvalidTenant") {
          setGeneralErrorMessage(metaDataConstants.invalidTenant)
        } else {
          setGeneralErrorMessage(metaDataConstants.somethingWrong)
        }
        setShowGeneralError(true)
        return
      }
    }
  }
  const submitForm = async (event, data) => {
    if (!data.isFormValid) {
      return false;
    }
    if (data.formData.username === "" || data.formData.username === undefined || data.formData.password === "" || data.formData.password === undefined || data.formData.textbox === "" || data.formData.textbox === undefined) {
      setShowGeneralError(true)
      setGeneralErrorMessage(metaDataConstants.fillRequiredFields)
      return false;
    }

    localStorage.setItem("config-api", process.env.REACT_APP_URL_CONFIG)

    setActivateLoader(true);

    // check tenant
    const metadataResponse = await getTenantMetaData(data?.formData?.textbox.toLocaleUpperCase());
    let response;
    if (metadataResponse) {
      response = await getServiceToken(data?.formData?.textbox.toLocaleUpperCase());
    } else {
      return
    }

    const payloadLogin = {
      userName: data.formData.username,
      password: data.formData.password,
      memberTypeId: "2",
      MEMBERID: 1,
      memberTypeName : "",
      tenantName: data.formData.textbox,
    }
    authenticationAPI(payloadLogin, response?.data.serviceToken.applicationTenantLinkId, response?.data.serviceToken.applicationKey, response?.data.serviceToken.tenantKey, response?.data.serviceToken.tokenId, response?.data.serviceToken.tokenKey)


    return true;
  };
  const getRoleBasedFeatureForOffline = async () => {
    const featureName = ["INMATE_SCANNING", "LOCATION_WISE_INVENTORY", "ACCOUNT_WISE_INVENTORY"]
    let feat;
    featureName.forEach(async feature => {
      const payload = {
        UserId: localStorage.getItem("userID"),
        FeatureName: feature,
      };
      const response = await post(ApiUrls().GET_ROLE_BASED_FEATUREACCESS, payload)
        .catch(function (error) {
          // Handle errors here
          console.error("Error:", error);
        });
      if (response?.status === 200) {
        console.log(response?.data);
        const dataString = response?.data?.result?.map(obj => obj.featureTypeName.toLocaleUpperCase())
        feat = { ...feat, [feature]: dataString }
        localStorage.setItem("feature", JSON.stringify(feat))
        addToCollection("FeatureAccess", feature, { [feature]: dataString })
          .catch((err) => console.log(err));
      }
    })
    return feat
  };

  const getConfigModuleAccess = async () => {
    const payload = {
      key: "PWAAPP_MENU"
    };
    const response = await post(ApiUrls().CONFIG_DATA_SEARCH, payload)
      .catch(function (error) {
        // Handle errors here
        console.error("Error:", error);
      });
    if (response?.status === 200) {
      localStorage.setItem('module_access', response?.data?.result[0]?.value)
      return response?.data?.result[0]?.value
    }
  };

  const authenticationAPI = async (payload, applicationTenantLinkId, applicationKey, tenantKey, tokenId, tokenKey) => {



    const response = await axios
      .post(
        ApiUrls().AUTHENTICATION_REQUEST,
        payload,
        {
          headers: {
            "Access-Application": applicationKey,
            "Client-Token": tenantKey,
            "ApplicationTenantLinkId": applicationTenantLinkId,
            "WebAccess-Token": tokenKey,
            "WebAccess-TokenId": tokenId,
            "IsExpirationCheckOptional": "true",
            "Content-Type": "application/json",
          },
        }
      )
      .catch(function (error) {
        // Handle errors here
        setActivateLoader(false);
        setShow(true)
        console.error("Error:", error);
      });


    if (response?.status === 200) {

      setActivateLoader(false);
      localStorage.setItem("email", response?.data.result.email)
      localStorage.setItem("token", response?.data.result.accessToken)
      localStorage.setItem("firstName", response?.data.result.firstName)
      localStorage.setItem("lastName", response?.data.result.lastName)
      localStorage.setItem("userName", response?.data.result.userName)
      localStorage.setItem("userID", response?.data.result.id)
      localStorage.setItem("isFirstLogin", true)

      //new things to be implemented from shibo too
      localStorage.setItem("tenantName", payload.tenantName)

      Promise.all([getRoleBasedFeatureForOffline(), getConfigModuleAccess()]).then(res => {
        navigate("/home");
      })
    } else {
      setActivateLoader(false)
      setShow(true)
    }
  }
  const forgotPass = () => {
    navigate("/forgotPassword");
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShow(false);
    setShowGeneralError(false);
  };


  const signInWithShibboleth = async (data) => {

    //  change this url for shibboleth login
    window.open(process.env.REACT_APP_SHIBBO,"_self")
    // window.open(process.env.REACT_APP_SHIBBO_TRAINING, "_self")
  }
  return (
    <div className="App">
      <div className="row justify-content-center align-items-center form-container">
        <div className="loginFormDiv col-lg-4 col-md-6">
          <div className="signInDiv text-center">
            <div className="logoParnter">
              <img src={cslogo1} alt="logo" className="cslogo" />
            </div>
            <Snackbar
              open={show}
              autoHideDuration={2000}
              onClose={() =>
                handleClose({ vertical: "bottom", horizontal: "right" })
              }
            >
              <Alert severity="error">{metaDataConstants.invalidCreds}</Alert>
            </Snackbar>
            <Snackbar
              open={showGeneralError}
              autoHideDuration={2000}
              onClose={() =>
                handleClose({ vertical: "bottom", horizontal: "right" })
              }
            >
              <Alert severity="error">{generalErrorMessage}</Alert>
            </Snackbar>
            <Signin
              Email={false}
              UserName={true}
              RememberMe={false}
              DropDown={false}
              TextBox={true}
              LabelTextBox={metaDataConstants.tenantLabel}
              Title=""
              titleAlign="left"
              SubmitButtonText={metaDataConstants.signInLabel}
              LableUsername={metaDataConstants.userNameLabel}
              PlaceholderUsername={metaDataConstants.userNamePlaceHolder}
              onSubmit={submitForm}
              onChange={rememberMe}
              onClick={forgotPass}
              design="material" // bootstrap
              materialOutline={true}
              showPassword={true}
              disableSubmit={false}
              // onBlur={this.onBlur}
              validationEvent="onchange" // onchange/blur
              extErrors={metaDataConstants.extErrors}
            />
            <div style={{ marginTop: "2px" }}>Or</div>
            <div style={{ marginTop: "5px" }}>
              <button
                className="passbtn"
                id="btnpwd"
                onClick={signInWithShibboleth}
              >
                <img className="micrsoftimg" src={shibbolethLogo} alt="logo" />
                {metaDataConstants.shibboSigninLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-pannel">
        <p style={{ marginBottom: "2px", paddingTop: "5px" }}>
          <a href={process.env.REACT_APP_RIT_TERMS_N_CON} target="_blank">{metaDataConstants.termsNCon}</a> | <a href={process.env.REACT_APP_RIT_PRIV_POL} target="_blank">{metaDataConstants.privacyPol}</a>
        </p>
        {/* <p style={{ marginTop: "0px", marginBottom: "0px" }}></p> */}
        <p style={{ marginBottom: "5px", paddingBottom: "5px" }}>{metaDataConstants.appFooter} ({packageJson.version})</p>
      </div>
      <div>
        <Loader active={activateLoader}></Loader>
      </div>
    </div>
  );
}

export default LogIn;
